import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { TermsAndConditionsPolicy } from "../MobilePolicyView/MobilePolicyView";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: "#fcfbfe", minHeight: "80vh", padding: "30px 0" }}>
      <Container style={{ maxWidth: "860px" }}>
        <div
          style={{
            background: "#ffffff",
            padding: "28px 24px",
            borderRadius: "14px",
            border: "1.5px solid #ede8f3",
            boxShadow: "0 1px 6px rgba(100, 32, 136, 0.04)",
          }}
        >
          <TermsAndConditionsPolicy />
        </div>
      </Container>
    </div>
  );
};

export default TermsAndConditions;
